import { Close as CloseIcon } from '@mui/icons-material';

const Close = (): JSX.Element => <CloseIcon fontSize="inherit" />;

export default Close;
